const $body = $('body');
const sForm = '.form-custom__form';
const sInputs = `${sForm} input, textarea`;
const sItem = '.form-custom__item';
const cItemError = 'form-custom__item-error';
const urlBook = document.querySelector('.form-custom__input_url-book');

$body.on('eksmoThisAjaxFormSuccess', sForm, function () {
    const $this = $(this);
    const $parent = $this.closest('.form-custom');

    if ($parent.length) {
        const h = $this.outerHeight(true);

        if ($(window).height() > h + 100) {
            $parent.height(h);
        } else {
            $('html, body').scrollTop($parent.offset().top - 100);
        }

        $parent.addClass('form-custom_success');
        $parent.html('<div class="form-custom__popup-success">Ваше сообщение успешно отправлено!</div>');
    }
});

$body.on('eksmoThisInputAjaxFormFail', sInputs, function (e, textError) {
    const $item = $(this).closest(sItem);

    if ($item.length) {
        const $error = $item.find(`.${cItemError}`);

        $error.remove();
        $item.append(`<div class="${cItemError}">${textError}</div>`);
    }
}).on('eksmoThisInputAjaxFormChange', sInputs, function () {
    const $item = $(this).closest(sItem);

    if ($item.length) {
        const $error = $item.find(`.${cItemError}`);

        $error.remove();
    }
});

urlBook?.addEventListener('keyup', () => {
    const value = urlBook.value;
    const elFormCustom = urlBook.closest('.form-custom__item');
    const elLoader = elFormCustom.querySelector('.form-custom__input_url-book-loader');
    const elAdditionSuccess = elFormCustom.querySelector('.form-custom__item-addition-box-success');
    const elAdditionError = elFormCustom.querySelector('.form-custom__item-addition-box-error');

    elLoader.classList.add('form-custom__input_url-book-loader_active');
    elAdditionSuccess?.classList.remove('form-custom__item-addition-box-success_active');
    elAdditionError.classList.remove('form-custom__item-addition-box-error_active');

    return fetch(value)
        .then((data) => data.text())
        .then((data) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');
            const bookName = doc.querySelector('.book-page__card-title').textContent;

            elAdditionSuccess.textContent = bookName;
            elLoader.classList.remove('form-custom__input_url-book-loader_active');
            elAdditionSuccess?.classList.add('form-custom__item-addition-box-success_active');
            elAdditionSuccess.setAttribute('href', value);
        })
        .catch(() => {
            elLoader.classList.remove('form-custom__input_url-book-loader_active');
            elAdditionError.classList.add('form-custom__item-addition-box-error_active');
        });
});